// 고장 조치 이력 (필드팀 유지보수 시트 수집분) — API 클라이언트.
//
// 시트 연동은 아직 없다. 지금 화면에 보이는 건 콘솔에서 편집한 값뿐이고,
// 수집이 붙으면 같은 목록에 시트 행이 쌓인다.
import type {
  CreateFaultRemediationDto,
  FaultRemediationDto,
  ListFaultRemediationsQuery,
  ListFaultRemediationsResponse,
  UpdateFaultRemediationDto,
} from '@bhops/shared';
import { apiClient } from './client';

export const faultRemediationsApi = {
  async list(q: ListFaultRemediationsQuery): Promise<ListFaultRemediationsResponse> {
    const { data } = await apiClient.get<ListFaultRemediationsResponse>('/fault-remediations', {
      params: q,
    });
    return data;
  },

  /** 월 탭 목록 — '전체 월' 드롭다운을 채운다. */
  async tabs(): Promise<string[]> {
    const { data } = await apiClient.get<string[]>('/fault-remediations/tabs');
    return data;
  },

  /** 문제 발생일(YYYY-MM-DD)의 다음 리포트 번호 — 'P261026-03'(2026-10-28). */
  async nextReportNo(date: string): Promise<string> {
    const { data } = await apiClient.get<{ reportNo: string }>(
      '/fault-remediations/next-report-no',
      { params: { date } },
    );
    return data.reportNo;
  },

  /** 콘솔에서 바로 작성(2026-10-27) — 캘린더 · 리포트 없이. */
  async create(dto: CreateFaultRemediationDto): Promise<FaultRemediationDto> {
    const { data } = await apiClient.post<FaultRemediationDto>('/fault-remediations', dto);
    return data;
  },

  async update(id: string, dto: UpdateFaultRemediationDto): Promise<FaultRemediationDto> {
    const { data } = await apiClient.patch<FaultRemediationDto>(`/fault-remediations/${id}`, dto);
    return data;
  },

  /** 소프트 삭제 — 행은 남고 목록에서만 사라진다. 되돌림은 서버의 restore. */
  async remove(id: string): Promise<{ id: string; deletedAt: string | null }> {
    const { data } = await apiClient.delete<{ id: string; deletedAt: string | null }>(
      `/fault-remediations/${id}`,
    );
    return data;
  },
};
